import type { TranslationKeys } from '@app/i18n/translationKeys';

// Exactly the labels the backend source views emit (41-global-search-sources.sql).
export const FIELD_LABELS = [
  'code',
  'national_id',
  'social_security_id',
  'phone',
  'email',
  'street',
  'city',
  'postal_code',
  'medications',
  'allergies',
  'category',
  'contact',
  'contact_phone',
  'contact_email',
  'attachment',
  'medical_history',
  'client_notes',
  'contact_notes',
  'visit_id',
  'cancel_reason',
  'caregiver',
  'request_id',
  'line',
  'request_notes',
  'client',
  'note_body',
  'caregiver_group',
  'skills',
  'specialties',
  'languages',
  'coverage_areas',
  'certifications',
  'specialization',
  'license_number',
  'shift_notes',
  'name',
  'role',
  'service_type',
  'description',
  'inventory_category',
  'payroll_notes',
] as const;

const KNOWN = new Set<string>(FIELD_LABELS);

export const fieldLabelKey = (label: string): TranslationKeys | undefined =>
  KNOWN.has(label) ? (`global-search-field-${label.replace(/_/g, '-')}` as TranslationKeys) : undefined;
